import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const subscribe = (data) =>
  axios.post(`${API}/subscribe`, data).then((r) => r.data);

export const sendInquiry = (data) =>
  axios.post(`${API}/contact`, data).then((r) => r.data);

export const trackClick = (label, url, section) => {
  try {
    axios.post(`${API}/track-click`, { label, url, section });
  } catch (e) {
    /* fire and forget analytics */
  }
};
